import apiFetch from '../apiFetch'

export default function (idAlbaran) {
  return apiFetch({endPoint: `Albaran/getAlbaran?idAlbaran=${idAlbaran}`, method: 'GET'})
}
